module.exports = __webpack_public_path__ + "img/null-data.a97ed149.png";